var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',{attrs:{"filterable":"","clearable":"","multiple":_vm.multiple},on:{"change":_vm.onChange},model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}},_vm._l((_vm.types),function(t){return _c('Option',{key:`hrmta_${t.id}`,attrs:{"value":t.id,"label":t.s1}},[_vm._v(_vm._s(t.s1)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }